import script from "./ProductGridSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductGridSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./ProductGridSkeleton.vue?vue&type=style&index=0&id=ee9d57cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee9d57cc"]])

export default __exports__